import { CircularProgress } from 'material-ui';
import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';
import raf from 'raf';

const onFrame = (fn) => {
  let requested = false;
  return (...args) => {
    if (requested) {
      return;
    }

    requested = true;
    raf(() => {
      fn(...args);
      requested = false;
    });
  };
};

const styles = {
  loaderWrapper: {
    margin: '8px 0',
    textAlign: 'center',
  },
};

class EndlessScrollView extends Component {
  constructor(props) {
    super(props);

    this.scrollHandler = onFrame(this.onScroll.bind(this));
    this.containerRef = createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollHandler);
  }

  onScroll() {
    const { inLoading, offset, onNextPage } = this.props;
    const { innerHeight } = window;
    const { current: el } = this.containerRef;

    if (!el || inLoading) {
      return;
    }

    const rect = el.getBoundingClientRect();
    const bottom = (rect.height + rect.top) - innerHeight;

    if (offset >= bottom && onNextPage) {
      onNextPage();
    }
  }

  render() {
    const { children, inLoading } = this.props;
    return (
      <div ref={this.containerRef}>
        {children}

        {inLoading && (
          <div style={styles.loaderWrapper}>
            <CircularProgress />
          </div>
        )}
      </div>
    );
  }
}

EndlessScrollView.propTypes = {
  children: PropTypes.node,
  inLoading: PropTypes.bool,
  offset: PropTypes.number,
  onNextPage: PropTypes.func.isRequired,
};

export default EndlessScrollView;



// WEBPACK FOOTER //
// ./src/components/EndlessScrollView.js